import { TDealType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function getHeadingType(dealType: TDealType) {
  return dealType === 'rent' ? 'seeRentalRateHistory' : 'seePriceHistory';
}
